import { changeVariantQuantity, selectProduct } from '@castlery/modules-product-domain';
import { useAppDispatch, useAppSelector } from '@castlery/shared-redux-store';
import { Stack, NumberInput, Button } from '@castlery/fortress';
import { useMount } from 'react-use';
import { refreshLeadtimeCommand } from '@castlery/modules-product-services';
/* eslint-disable-next-line */
export interface VariantQuantityProps {
  disabled?: boolean;
  currentVariantId?: number;
}

export function VariantQuantity({ disabled, currentVariantId }: VariantQuantityProps) {
  const dispatch = useAppDispatch();
  const currentProduct = useAppSelector(selectProduct);
  const defaultValue = currentProduct?.qty_increments || 1;

  useMount(() => {
    dispatch(changeVariantQuantity(defaultValue));
  });

  return (
    <Stack
      // key={currentVariant?.id}
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        'div > input': {
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          '&:focus': {
            border: 'none',
            boxShadow: 'none',
          },
        },
        'div > button': {
          border: (theme) => `1px ${theme.palette.brand.wheat[500]} solid`,
        },
        'div > button:hover': {
          backgroundColor: 'transparent',
        },
        // mt: -1,
      }}
    >
      <NumberInput
        step={currentProduct?.qty_increments}
        defaultValue={defaultValue}
        min={defaultValue}
        max={99}
        readOnly={true}
        // disabled={disabled}
        onChange={(event, value) => {
          if (!value) return;
          dispatch(changeVariantQuantity(value));
          dispatch(refreshLeadtimeCommand({})).unwrap();
        }}
        slotProps={{
          input: {
            sx: {
              '&:focus': {
                border: 'none',
              },
            },
          },
          incrementButton: {
            children: (
              <Button
                disabled={disabled}
                sx={{
                  backgroundColor: 'transparent',
                  color: (theme) => theme.palette.brand.wheat[500],
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  '&:active': {
                    backgroundColor: 'transparent',
                  },
                  '&:disabled': {
                    cursor: 'not-allowed !important',
                  },
                  cursor: disabled ? 'not-allowed !important' : 'pointer',
                }}
              >
                +
              </Button>
            ),
            disabled: disabled,
            sx: {
              order: 1,
              maxWidth: '24px',
              maxHeight: '24px',
              overflow: 'hidden',
              cursor: disabled ? 'not-allowed !important' : 'pointer',
            },
          },
          decrementButton: {
            children: (
              <Button
                sx={{
                  backgroundColor: 'transparent',
                  color: (theme) => theme.palette.brand.wheat[500],
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                  '&:active': {
                    backgroundColor: 'transparent',
                  },
                }}
              >
                -
              </Button>
            ),
            sx: {
              maxWidth: '24px',
              maxHeight: '24px',
              overflow: 'hidden',
            },
          },
        }}
      />
    </Stack>
  );
}
